module.exports = "/dist/img/noshi03.fe788043.jpg";